import React, { useEffect } from 'react';
import { Button, Form, Input, Typography, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import './index.css';

const { Text } = Typography;

interface LoginFormData {
  username: string;
  password: string;
}

const LoginTechPage: React.FC = () => {
  const [form] = Form.useForm<LoginFormData>();
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading, error, clearError, isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated) {
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    if (error) {
      message.error(error);
      clearError();
    }
  }, [error, clearError]);

  const handleLogin = async (values: LoginFormData) => {
    const result = await login(values);
    if (result.success) {
      message.success(result.message);
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
      return;
    }
    message.error(result.message);
  };

  return (
    <div className="login-tech-root">
      <div className="login-tech-shell">
        <div className="login-tech-panel">
          <div className="login-tech-header">
            <div className="login-tech-badge">
              <span className="login-tech-dot" />
              Secure Access
            </div>
            <h1 className="login-tech-title">
              <span>斌宇林建</span>
            </h1>
            <p className="login-tech-subtitle">项目管理系统 · 高级科技感原型</p>
          </div>

          <Form
            form={form}
            name="login-tech"
            onFinish={handleLogin}
            layout="vertical"
            size="large"
            className="login-tech-form"
            requiredMark={false}
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: '请输入用户名' },
                { min: 3, message: '用户名至少3个字符' },
                { max: 30, message: '用户名不能超过30个字符' },
                { pattern: /^[a-zA-Z0-9_]+$/, message: '用户名只能包含字母、数字和下划线' },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="用户名" autoComplete="username" />
            </Form.Item>

            <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="密码" autoComplete="current-password" />
            </Form.Item>

            <div className="login-tech-actions">
              <Button type="primary" htmlType="submit" loading={loading}>
                进入系统
              </Button>
            </div>
          </Form>

          <div className="login-tech-divider" />

          <div className="login-tech-foot">
            <Text type="secondary">仅内部使用 · vPrototype</Text>
            <a className="login-tech-link" href="/login-minimal">
              切换极简
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginTechPage;
